/* eslint-disable */
import React from 'react';
import { Container } from '@material-ui/core';
import useAppSearchParams from 'src/hooks/useAppSearchParams';
import { Carousel, Col, Flex, Image, Row, Typography } from 'antd';
import { SNBLRegisterForm } from './register-form';
import useMediaQuery from 'src/hooks/useMediaQuery';
import { SNBLNav } from './snbl-nav';

export const SNBLRegister: React.FC = () => {
  const { getSearchParam } = useAppSearchParams();
  const merchantId = getSearchParam('merchantId');
  const { isMobile } = useMediaQuery();

  const contentStyle: React.CSSProperties = {
    height: '100px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
  };

  const boxStyle: React.CSSProperties = {
    width: '100%',
    height: 120,
    overflowX: 'auto',
  };

  return (
    <main style={{ height: '80vh' }} className="d-flex justify-content-between flex-column">
      <SNBLNav />
      <Container maxWidth="lg" className={`${isMobile ? 'px-3' : 'px-6'}`}>
        <h1>{merchantId}</h1>
        <div style={{ gap: '4rem' }}>
          <Row gutter={[24, 24]} justify="space-between">
            <Col xs={24} style={{ width: '100%' }}>
              <Carousel autoplay autoplaySpeed={3000} fade dots={false} style={{ width: '100%' }}>
                <Flex style={boxStyle} justify="space-around" wrap="nowrap" align="center">
                  <Image preview={false} style={contentStyle} src="img/snbl/apple.png" />
                  <Image preview={false} style={contentStyle} src="img/snbl/BA.png" />
                  <Image preview={false} style={contentStyle} src="img/snbl/lg.png" />
                  <Image preview={false} style={contentStyle} src="img/snbl/spar.svg" />
                  <Image preview={false} style={contentStyle} src="img/snbl/benz.png" />
                </Flex>
                <Flex style={boxStyle} justify="space-around" wrap="nowrap" align="center">
                  <Image preview={false} style={contentStyle} src="img/snbl/ebeano.jpeg" />
                  <Image preview={false} style={contentStyle} src="img/snbl/shoprite.png" />
                  <Image preview={false} style={contentStyle} src="img/snbl/samsung.jpg" />
                  <Image preview={false} style={contentStyle} src="img/snbl/wakanow.jpg" />
                </Flex>
              </Carousel>
            </Col>
            <Col xs={24} md={12}>
              <div>
                <div>
                  <Typography.Title level={4}>
                    Got your eyes on something big? With Save Now, Buy Later, AjoCard helps you put money aside gradually for your major purchases
                    without the pressure of upfront payment.
                  </Typography.Title>
                  <Typography.Title level={4}>
                    Powered by our CBN-licensed and NDIC-insured Microfinance Bank, this product gives you a safe, structured way to reach your
                    financial goals whether it’s a gadget, home upgrade, or personal milestone.
                  </Typography.Title>
                  <Typography.Title level={4}>Start saving today and buy when you're ready the smart way.</Typography.Title>
                  <Typography.Title level={3}>PROCESS</Typography.Title>
                </div>
                <ul>
                  <li>
                    <Typography.Text>Enter your phone number</Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>Create your PIN</Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>Receive funding instructions</Typography.Text>
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <SNBLRegisterForm />
            </Col>
          </Row>
        </div>
      </Container>
      <div className="w-100">
        <div className="mx-auto d-flex align-center" style={{ width: 'max-content', gap: '1rem' }}>
          <Typography.Text>Powered by</Typography.Text>
          <div className="d-flex align-center">
            <img className="img-fluid" src="/logo.svg" alt="ajocard-logo" />
            <h4 className="m-0">AjoCard</h4>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SNBLRegister;
